<template>
  <v-dialog
    persistent
    v-model="dialog"
    @keydown.esc="dialog = false"
    width="850"
    scrollable
  >
    <v-form ref="form" @submit.prevent lazy-validation v-model="valid">
      <v-card class="elevation-3">
        <v-card-title class="primary text-h5 white--text">
          {{ modalText }}
        </v-card-title>
        <v-card-text class="pa-4">
          <!-- <v-row>
            <v-col sm="12">
              <v-text-field
                label="Tracked Bill ID"
                v-model="selectedLink.TrackedBillID"
                type="number"
                :rules="[(v) => !!v || 'required']"
              ></v-text-field>
            </v-col>
          </v-row> -->
          <v-row>
            <v-col sm="12">
              <v-text-field
                label="Description"
                v-model="selectedLink.Description"
                :rules="[(v) => !!v || 'required']"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col sm="12">
              <v-text-field
                label="URL"
                v-model="selectedLink.URL"
                :rules="[(v) => !!v || 'required']"
              ></v-text-field>
            </v-col>
          </v-row>
          <!-- <v-row>
            <v-col sm="12">
              <v-text-field
                label="Created By ID"
                v-model="selectedLink.CreatedByID"
                type="number"
                :rules="[(v) => !!v || 'required']"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col sm="12">
              <BaseDatePickerWithText
                label="Created Date mm/dd/yyyy"
                v-model="selectedLink.CreatedDate"
              ></BaseDatePickerWithText>
            </v-col>
          </v-row> -->
          <!-- <v-row>
            <v-col sm="12">
              <v-checkbox
                label="Is Deleted"
                v-model="selectedLink.IsDeleted"
                :rules="[(v) => v === true || v === false || 'required']"
              ></v-checkbox>
            </v-col>
          </v-row> -->
        </v-card-text>
        <v-card-actions>
          <v-btn @click="saveLinkDetails" :disabled="saving" color="primary"
            >Save</v-btn
          >
          <v-btn outlined color="primary" @click="cancelEntry">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>
<script>
import { get, sync, commit, call } from 'vuex-pathify'
import Link from '@classes/Link'
//templateTODO: import lookup components you plan to use
export default {
  components: {},
  data: () => ({
    dialog: false,
    valid: true,
    selectedLink: new Link(),
    modalText: '',
  }),
  created() {},
  computed: {
    ...get('link', ['saving']),
    billID() {
      if (this.$route.params.id) {
        return parseInt(this.$route.params.id)
      }
    },
  },
  methods: {
    handleError: call('errors/handleError'),
    ...call('link', ['saveLink']),
    async validate() {
      this.$refs.form.validate()
    },
    editLink(entry) {
      this.selectedLink = new Link(entry)
      this.modalText = 'Edit Link'
      this.dialog = !this.dialog
    },
    addLink() {
      this.modalText = 'Insert Link'
      this.selectedLink = new Link({ TrackedBillID: this.billID })
      this.dialog = !this.dialog
    },
    saveLinkDetails() {
      this.validate().then(() => {
        if (this.valid) {
          //templateTODO: if you want to save related item arrays you will need to add a getSaveData() function to the javascript class and call that instead
          this.saveLink(this.selectedLink.removeRelated()).then(
            (res) => {
              this.$emit('refresh')
              this.selectedLink = new Link()
              this.$refs.form.resetValidation()
            },
            (err) => {}
          )
          this.dialog = false
        }
      })
    },
    cancelEntry() {
      this.dialog = false
      this.selectedLink = new Link()
      this.$refs.form.resetValidation()
    },
  },
}
</script>
<style></style>
